import { Target, Zap, TrendingUp } from 'lucide-react';

const pillars = [
    {
        icon: Target,
        title: 'Gap-based diagnosis',
        description: 'Quantifies what a learner knows, what they don\'t, and what matters most on an exam-aligned scale.',
    },
    {
        icon: Zap,
        title: 'Zero-waste practice',
        description: 'Practice questions are ranked by expected score gain, suppressing mastered or low-impact content.',
    },
    {
        icon: TrendingUp,
        title: 'Transparent progress',
        description: 'Progress is measurable, comparable over time, and directly tied to exam readiness.',
    },
];

const ValuePillars = () => {
    return (
        <section className="bg-muted/20 border-y border-border/50">
            <div className="container mx-auto max-w-4xl px-6 py-12">
                <h2 className="sr-only">Why Pinpoint</h2>
                <div className="grid md:grid-cols-3 gap-6">
                    {pillars.map((pillar, index) => (
                        <div key={index} className="text-center">
                            <div className="w-10 h-10 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center mx-auto mb-3">
                                <pillar.icon className="w-5 h-5 text-primary" />
                            </div>
                            <h3 className="text-base font-semibold text-foreground mb-1.5">
                                {pillar.title}
                            </h3>
                            <p className="text-base text-muted-foreground leading-relaxed">
                                {pillar.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ValuePillars;
